import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function loadHubSpotScript() {
  return new Promise((resolve, reject) => {
    if (document.getElementById("hs-script-loader")) {
      resolve("HubSpot script already loaded.");
      return;
    }

    window.hsConversationsSettings = {
      loadImmediately: false,
    };

    const script = document.createElement("script");
    script.src = "https://js.hs-scripts.com/25299463.js";
    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      resolve("HubSpot script loaded successfully.");
    };

    script.onerror = () => {
      reject("Error loading HubSpot script.");
    };

    document.body.appendChild(script);
  });
}

function useHubSpotChat({ isNative }: { isNative: boolean }) {
  const location = useLocation();
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    const path = location.pathname;
    const isBlockedRoute =
      isNative ||
      path.includes("/install") ||
      path.includes("/pdf-preview") ||
      path.includes("/pdf-report") ||
      path.includes("/privacy") ||
      path.includes("/qr/hw/develco/") ||
      path.includes("download-app");

    const handleWidget = () => {
      if (!window.HubSpotConversations || !window.HubSpotConversations.widget) {
        return;
      }

      if (isBlockedRoute) {
        window.HubSpotConversations.widget.remove();
      } else {
        window.HubSpotConversations.widget.load();
      }
    };

    const loadAndHandle = async () => {
      if (scriptLoadedRef.current) {
        handleWidget(); // script is already loaded, just handle widget
        return;
      }

      if (isBlockedRoute) {
        return; // don't load script on blocked routes
      }

      try {
        await loadHubSpotScript();
        scriptLoadedRef.current = true;

        // wait until the API is ready
        window.hsConversationsOnReady = window.hsConversationsOnReady || [];
        window.hsConversationsOnReady.push(handleWidget);
      } catch (e) {
        console.error("Error loading HubSpot:", e);
      }
    };

    loadAndHandle();
  }, [isNative, location.pathname]);
}

export default useHubSpotChat;
